import React  from 'react';

import Snackbar          from '@material-ui/core/Snackbar';
import CloseIcon         from '@material-ui/icons/Close';
import Slide             from '@material-ui/core/Slide';

import WarningIcon       from '@material-ui/icons/Warning';
import InfoIcon          from '@material-ui/icons/Info';
import ErrorIcon         from '@material-ui/icons/Error';
import CheckCircleIcon   from '@material-ui/icons/CheckCircle';

import 'styles/snackbar.css';

function Component (props) {
	const { open, message, type, handleClose } = props;
/*
 *
 *    const SlideTransition = (props) => {
 *        return <Slide {...props} direction="down" in={open} mountOnEnter unmountOnExit />;
 *    };
 */

	const getAlert = () => {
		let _type = type;
		let icon = <WarningIcon className="snackbar-icon" />;

		if (type !== ("error" || "warn" || "info" || "success")) 
			_type = "warn";

		switch (_type) {
			case "error":
				icon = <ErrorIcon className="snackbar-icon" />;
				break;

			case "warn":
				icon = <WarningIcon className="snackbar-icon" />;
				break;

			case "info":
				icon = <InfoIcon className="snackbar-icon" />;
				break;

			case "success":
				icon = <CheckCircleIcon className="snackbar-icon" />;
				break;

			default:
				icon = <WarningIcon className="snackbar-icon" />;
		}

		return (
			<div className={`snackbar-container snackbar-${_type}-container`}>
				{ icon }
				<span className="snackbar-span" id="message-id">{ message }</span>
				<CloseIcon className="snackbar-close" onClick={ handleClose } />
			</div>
			);
	};

	React.useEffect (() => {
	}, [open]);
	
			/*
			 *TransitionComponent={SlideTransition}
			 */
	return (
		<Snackbar
			anchorOrigin={{
			vertical: 'top',
			horizontal: 'center',
			}}
			open={open}
			autoHideDuration={6000}
			onClose={handleClose}
		>
			{ getAlert () }
		</Snackbar>
		);
}

export default Component;
